// Display a list of checkbox options to show/hide grid columns (CPGridV2 version)
import * as React from "react";
import { CPGridV2Column } from "../types";
import CPSelectList, {
  CPSelectListItem,
} from "shared/components/shared/CPSelectList/CPSelectList";

interface CPShowHideListProps {
  columns: CPGridV2Column[];
  onUpdate: (column: CPGridV2Column) => void;
}

const CPShowHideList: React.FC<CPShowHideListProps> = (props) => {
  const data = props.columns
    .filter((x) => !x.pinned && x.columnType !== "menu")
    .map((x) => ({ text: x.title, checked: !x.hide }));

  const handleSelect = (selectedItem: CPSelectListItem) => {
    const item = props.columns.find((item) => item.title === selectedItem.text);

    if (item) {
      props.onUpdate({ ...item, hide: !item.hide });
    }
  };

  return <CPSelectList data={data} onSelect={handleSelect} />;
};

export default CPShowHideList;
